import { Component, OnInit } from '@angular/core';
import { IonicModule, ModalController } from '@ionic/angular';
import { AuthModalComponent } from 'src/app/modals/auth/auth.modal';
import { AuthService } from 'src/app/providers/auth/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.page.html',
  styleUrls: ['./auth.page.scss'],
  standalone: true,
  imports: [IonicModule],
})
export class AuthPage implements OnInit {
  public loggedIn = false;
  private authForm: HTMLIonModalElement;

  constructor(
    private modalController: ModalController,
    private auth: AuthService,
    private router: Router,
  ) { }

  ngOnInit() {
    this.auth.isAuthenticated().subscribe(loggedIn => {
      if (loggedIn) {
        this.router.navigate(['/home'], { replaceUrl: true });
      }
    });
  }

  async ionViewWillEnter() {
    this.loggedIn = this.auth.loggedIn.getValue();

    this.authForm = await this.modalController.create({
      component: AuthModalComponent,
      backdropDismiss: false,
      cssClass: 'modal-fullscreen',
    });

    if (this.loggedIn) {
      this.router.navigate(['/home'], { replaceUrl: true });
    } else {
      this.authForm.present();
    }
  }

  ionViewDidLeave() {
    this.authForm?.dismiss();
  }

}
